import { useMemo } from 'react';

/**
 * Hook para gerenciar mensagens e constantes do Flow
 */
const useFlowConstants = (intl) => {
  // Mensagens de sucesso e erro
  const MESSAGES = useMemo(() => ({
    SUCCESS: {
      CREATE: intl.formatMessage({ id: "flow.created.success" }),
      EDIT: intl.formatMessage({ id: "flow.updated.success" }),
    },
    ERROR: {
      CREATE: intl.formatMessage({ id: "flow.created.error" }),
      EDIT: intl.formatMessage({ id: "flow.updated.error" }),
    },
  }), [intl]);

  // Mensagens de feedback para delete
  const DELETE_MESSAGES = useMemo(() => ({
    SUCCESS: intl.formatMessage({ id: "flow.deleted.success" }),
    ERROR: intl.formatMessage({ id: "flow.deleted.error" }),
  }), [intl]);

  return {
    MESSAGES,
    DELETE_MESSAGES
  };
};

export default useFlowConstants;